import React from "react";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

import Button from "components/Button";

import { ReactComponent as SearchIcon } from "assets/images/search-icon.svg";
import { ReactComponent as ClearIcon } from "assets/images/icon_close_modal.svg";

import { styles } from "./styles";

interface SearchInputProps {
  value: string;
  onClear: () => void;
  onChange: (text: string) => void;
  handleSearchSubmit: (value?: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onClear,
  onChange,
  handleSearchSubmit,
  placeholder,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSearchSubmit();
    }
  };

  return (
    <TextField
      sx={styles.input}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder || "Пошук"}
      variant="outlined"
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" sx={{ display: "flex", gap: 1 }}>
              {value && (
                <IconButton onClick={onClear}>
                  <ClearIcon />
                </IconButton>
              )}
              <Button
                sx={styles.button}
                variant="contained"
                color="primary"
                onClick={() => handleSearchSubmit()}
              >
                Пошук
              </Button>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default React.memo(SearchInput) as typeof SearchInput;
